import React from 'react';
import PropTypes from 'prop-types';
import { Link, Navigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import useAuth from 'hooks/useAuth';

const ForgetPasswordForm = () => {
 const { handleFieldChange, handleSubmit, formData, success } = useAuth('passForgot', {
  email: '',
  url: 'http://localhost:3000/authentication/card/reset-password/'
 });

 return success ? (
  <Navigate to="/authentication/card/confirm-mail" />
 ) : (
  <Form className="mt-4" onSubmit={handleSubmit}>
   <Form.Group className="mb-3">
    <Form.Control placeholder={'Email address'} value={formData.email} name="email" onChange={handleFieldChange} type="email" />
   </Form.Group>

   <Form.Group className="mb-3">
    <Button className="w-100" type="submit" disabled={!formData.email}>
     Enviar link
    </Button>
   </Form.Group>

   <Link className="fs--1 text-600" to="#!">
    No puedo recobrar mi cuenta usando esta página
    <span className="d-inline-block ms-1"> &rarr;</span>
   </Link>
  </Form>
 );
};

ForgetPasswordForm.propTypes = {
 layout: PropTypes.string
};

ForgetPasswordForm.defaultProps = { layout: 'simple' };

export default ForgetPasswordForm;
